import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { SecureImageModule } from "src/app/ui-widgets/secure-image/secure-image.module";
import { HeaderModule } from "src/app/ui-widgets/header/header.module";
import { SidebarModule } from "src/app/ui-widgets/sidebar/sidebar.module";
import { ProfileComponent } from "./profile.component";
import { NgxMaskModule } from "ngx-mask";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { UploadPhotoComponent } from './upload-photo/upload-photo.component';
import { UserPhotoUploaderModule } from "src/app/ui-widgets/user-photo-uploader/user-photo-uploader.module";
import { ProfileRoutingModule } from "./profile-routing.module";
import { AddressFormComponent } from "src/app/ui-widgets/forms/address-form/address-form.component";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    HeaderModule,
    FormsModule,
    ReactiveFormsModule,
    SidebarModule,
    SecureImageModule,
    NgxMaskModule.forRoot(),
    NgxUiLoaderModule,
    UserPhotoUploaderModule,
    ProfileRoutingModule,
    AddressFormComponent
  ],
  declarations: [
    ProfileComponent,
    UploadPhotoComponent
  ]
})
export class ProfileModule { }
